import type { SpaceType } from 'features/space/types/spaceDetail'

export function getSpaceBookingCalendarMaxMonths(spaceType: SpaceType): 1 | 3 {
  switch (spaceType) {
    case 'pudo':
    case 'locker':
    case 'coin_locker':
    case 'multiecube':
      return 1
    case 'normal':
    case 'jr_east':
    case 'japan_post':
    case 'jr_west':
    case 'nta':
    case 'apaman':
      return 3
    default: {
      const exhaustiveCheck: never = spaceType
      return exhaustiveCheck
    }
  }
}
